import styled from '@tanium/react-emotion';
import { css, LayoutStyleProps } from '@tanium/style-system';
import { ThemeFontWeights } from '@tanium/theme-data';
import { TermText } from './themeDefinitions';

export type DefinitionTermProps = {
  verticalAlign: LayoutStyleProps['verticalAlign'];
};

export const DefinitionTerm = styled('dt')<DefinitionTermProps>((props) =>
  css({
    display: 'table-cell',
    color: TermText,
    fontWeight: ThemeFontWeights.Normal,
    wordBreak: 'keep-all',
    verticalAlign: props.verticalAlign,
  }),
);
